import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { stripUnit } from 'polished'

import fluidRange from '../../utils/fluidRange'
import { ListItem } from '../List/List.styles'

export const Content = styled.div(
  ({ theme, hasChildren, alignMainContent, hasBackgroundImage }) => css`
    display: flex;
    flex-direction: column;
    align-items: ${alignMainContent === 'left' ? 'flex-start' : 'center'};
    ${hasBackgroundImage && 'position: relative;'}
    position: relative;
    z-index: 2;

    .content {
      display: flex;
      flex-direction: column;
      text-align: ${alignMainContent === 'left' ? 'left' : 'center'};
    }

    ${hasChildren &&
    fluidRange('margin-bottom', [
      stripUnit(theme?.spacing?.xs),
      stripUnit(theme?.spacing?.sm),
    ])};

    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    p,
    a {
      text-align: ${alignMainContent === 'left' ? 'left' : 'center'};
    }

    a {
      display: inline-flex;
      justify-content: ${alignMainContent === 'left' ? 'flex-start' : 'center'};
    }

    ${ListItem} {
      p {
        text-align: left;
      }
    }

    @media (min-width: ${theme?.breakpoints?.lg}) {
      width: 80%;
      margin-left: auto;
      margin-right: auto;

      .mobile-image {
        display: none;
      }
    }
  `
)
export const DesktopImage = styled.div(
  ({ theme, alignImageToBottom }) => css`
    @media (max-width: 539px) {
      display: none;
    }

    .gatsby-image-wrapper {
      margin-top: ${alignImageToBottom ? theme?.spacing?.md : '0'};
      margin-bottom: ${!alignImageToBottom ? theme?.spacing?.md : '0'};
    }
  `
)

export const MobileImage = styled.div(
  ({ theme, mobileAlignImageToBottom }) => css`
    @media (min-width: ${theme?.breakpoints?.sm}) {
      display: none;
    }

    .gatsby-image-wrapper {
      margin-top: ${mobileAlignImageToBottom ? theme?.spacing?.md : '0'};
      margin-bottom: ${!mobileAlignImageToBottom ? theme?.spacing?.md : '0'};
    }
  `
)

export const BGImage = styled.div`
  display: block;
  position: absolute !important;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  // In decoupling from Gatsby image, i need to target the inline styles generated by gatsby on that div
  > .gatsby-image-wrapper,
  > .sylex-image {
    position: initial !important;

    // Gatsby Image has inline-styles with padding-bottom overflow into other sections.
    > div {
      padding-bottom: 0 !important;
    }

    picture {
      img {
        height: 100%;
      }
    }
  }

  > img {
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
`

export const BackgroundImage = styled(BGImage)`
  ${(props) =>
    props.mobileBackgroundImage &&
    `
    @media (max-width: 539px) {
      display: none;
    }
  `}
`

export const MobileBackgroundImage = styled(BGImage)`
  @media (min-width: ${(props) => props.theme?.breakpoints?.sm}) {
    display: none;
  }
`
